<app-update-distributor *ngIf="distributorData" [distributorDataInput]="distributorData"></app-update-distributor>

<div class="bg-white p-3 rounded-5 mb-3 shadow">

    <!--#region - Tab List - -->
    <ul class="nav nav-tabs mb-3" id="transferTypeTab" role="tablist">
        <li class="nav-item" role="presentation">
            <button class="nav-link" [class.active]="currentTab === 'partners'" id="partners-tab-header" data-bs-toggle="tab" data-bs-target="#partners-tab" type="button" role="tab" aria-selected="false" tabindex="-1">
                Partners
            </button>
        </li>
        <li class="nav-item" role="presentation">
            <button class="nav-link" [class.active]="currentTab === 'customers'" id="customers-tab-header" data-bs-toggle="tab" data-bs-target="#customers-tab" type="button" role="tab" aria-selected="false" tabindex="-1">
                Customers
            </button>
        </li>
        <li class="nav-item" role="presentation">
            <button class="nav-link" [class.active]="currentTab === 'staff'" id="staff-tab-header" data-bs-toggle="tab" data-bs-target="#staff-tab" type="button" role="tab" aria-selected="false" tabindex="-1">
                Staff
            </button>
        </li>
    </ul>
    <!--#endregion - Tab List - -->
    <div class="tab-content">
        <!--#region - Partners Tab - -->
        <div class="tab-pane fade" [class.show]="currentTab === 'partners'" [class.active]="currentTab === 'partners'" id="partners-tab" role="tabpanel" aria-labelledby="#partners-tab-header">
            <div class="row" *ngIf="currentTab==='partners'">
                <app-list-distributor-partners *ngIf="distributorData" [distributorDataInput]="distributorData"></app-list-distributor-partners>
            </div>
        </div>
        <!--#endregion - Partners Tab - -->
        <!--  -->
        <!--#region - Customers Tab - -->
        <div class="tab-pane fade" [class.show]="currentTab === 'customers'" [class.active]="currentTab === 'customers'" id="customers-tab" role="tabpanel" aria-labelledby="#customers-tab-header">
            <div class="row" *ngIf="currentTab==='customers'">
                <app-list-distributor-customer *ngIf="distributorData" [distributorDataInput]="distributorData"></app-list-distributor-customer>
            </div>
        </div>
        <!--#endregion - Customers Tab - -->
        <!--  -->
        <!--#region - Staff Tab - -->
        <div class="tab-pane fade" [class.show]="currentTab === 'staff'" [class.active]="currentTab === 'staff'" id="staff-tab" role="tabpanel" aria-labelledby="#staff-tab-header">
            <div class="row" *ngIf="currentTab==='staff'">
                <app-list-distributor-staff *ngIf="distributorData" [distributorDataInput]="distributorData"></app-list-distributor-staff>
            </div>
        </div>
        <!--#endregion - Staff Tab - -->
    </div>
</div>
